const RENTALS_PROPERTIES = {
  //getProperties
  RENTALS_PROPERTIES: 'RENTALS_PROPERTIES',
  //getProperty
  RENTALS_PROPERTY: 'RENTALS_PROPERTY',
  //getPropertyUnits
  RENTALS_PROPERTY_UNITS: 'RENTALS_PROPERTY_UNITS',
  //getPropertyUnitsNoParams
  RENTALS_PROPERTY_UNITS_NO_PARAMS: 'RENTALS_PROPERTY_UNITS_NO_PARAMS',
  //getPropertyPriceList
  RENTALS_PROPERTY_PRICE_LIST: 'RENTALS_PROPERTY_PRICE_LIST',
  //printPropertyPriceList
  RENTALS_PROPERTY_PRICE_LIST_PRINT: 'RENTALS_PROPERTY_PRICE_LIST_PRINT',
  //getPropertyUnitsDiscounts
  RENTALS_PROPERTY_UNIT_DISCOUNTS: 'RENTALS_PROPERTY_UNIT_DISCOUNTS',
  //getPropertyTranslations
  RENTALS_PROPERTY_TRANSLATIONS: 'RENTALS_PROPERTY_TRANSLATIONS',
  //getUsers
  RENTALS_USERS: 'RENTALS_USERS',
  //getUsersAll
  RENTALS_USERS_ALL: 'RENTALS_USERS_ALL',
};

export default RENTALS_PROPERTIES;
